// Aviso do sistema operacional, o que aparece mesmo com a aba em segundo
// plano.
//
// Dois cuidados que não são detalhe: a permissão só pode ser pedida DURANTE um
// clique (navegador ignora — ou bloqueia de vez — pedido que nasce de um
// efeito), e `new Notification()` não existe no Android, onde a única forma é
// pelo service worker da PWA. Por isso as duas funções moram aqui, e não
// espalhadas na tela que precisa delas.

export const podeAvisar = () =>
  typeof window !== "undefined" && "Notification" in window;

// Chame dentro do clique que liga o aviso. Devolve a permissão final.
export const pedirPermissaoDeAviso = async () => {
  if (!podeAvisar()) return "denied";
  if (Notification.permission !== "default") return Notification.permission;

  try {
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
};

export const mostrarAviso = async (titulo, corpo, tag) => {
  if (!podeAvisar() || Notification.permission !== "granted") return false;

  const opcoes = { body: corpo, tag };

  // Service worker primeiro: no Android o construtor lança
  // "Illegal constructor", e este é o único caminho que funciona.
  //
  // `getRegistration()` e não `ready`: `ready` nunca rejeita e fica pendente
  // para sempre quando não há service worker ativo (o caso do desenvolvimento),
  // e aí a reserva abaixo nunca chegava a rodar.
  try {
    const registro = await navigator.serviceWorker?.getRegistration();

    if (registro) {
      await registro.showNotification(titulo, opcoes);
      return true;
    }
  } catch {
    // Cai para o construtor.
  }

  try {
    new Notification(titulo, opcoes);
    return true;
  } catch {
    return false;
  }
};
